import React from "react";

import Announcement from "@mapmycustomers/shared/types/announcements/Announcement";

import styles from "./AnnouncementCard.module.scss";
import AnnouncementMedia from "./AnnouncementMedia";

interface AnnouncementCardProps {
  announcement: Announcement;
}

const AnnouncementCard = ({ announcement }: AnnouncementCardProps) => (
  <div className={styles.container}>
    <AnnouncementMedia
      announcementId={announcement.id}
      contentType={announcement.fileContentType}
      url={announcement.fileUrl}
    />
    <div className={styles.body}>
      <div className={styles.title}>{announcement.title}</div>
      <div className={styles.description}>{announcement.description}</div>
    </div>
  </div>
);

export default AnnouncementCard;
